import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { CatPais } from '../interface/catpais.interface';
import { Product } from '../interface/products/product.interface';
import { PaymentMethod } from '../interface/products/paymentMethod.interface';
import { ProductCalculatePrice } from '../interface/products/productCalculation.interface';
import { PaymentPlanCalculation } from '../interface/paymentPlanCalc.interface';
import { Transaction } from '../interface/transaction.interface';
import { CreateClientTransactionInvoice } from '../interface/createClientTransactionInvoice.interface';
import { UserData } from '../interface/userData.interface';
import { ClientData } from '../interface/client.interface';
import { publicPageErrors } from '../interceptors/data-service.interceptor';

export interface FirstPaymentStatus {
  success: boolean;
  ready: boolean;
  invoiceLink: string | null;
  amount: number;
  paid: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LandingPagesService {
  private baseUrl = environment.baseUrl
  private apiKey= environment.hashKey
  private reqHeader: HttpHeaders;


  constructor(private http: HttpClient) {
    this.reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': `${this.apiKey}`
    });
  }

  getCatalogoPaises():Observable<CatPais[]>{
    return this.http.get<CatPais[]>(`${this.baseUrl}/public/countries`, { headers: this.reqHeader, context: publicPageErrors() });
  }

  getProductos():Observable<Product[]>{
    return this.http.get<Product[]>(`${this.baseUrl}/public/products/active`, { headers: this.reqHeader, context: publicPageErrors() });
  }

  getPaymentMethod(idPaymentMethod: number): Observable<PaymentMethod> {
    return this.http.get<PaymentMethod>(`${this.baseUrl}/public/payment-methods/${idPaymentMethod}`, { headers: this.reqHeader, context: publicPageErrors() });
  }

  getUserAgent(idUser: number):Observable<UserData>{
    return this.http.get<UserData>(`${this.baseUrl}/public/agents/${idUser}`, { headers: this.reqHeader, context: publicPageErrors() })
  }

  getClientByEmail(email: string):Observable<ClientData | null>{
    return this.http.get<ClientData | null>(`${this.baseUrl}/public/clients/email-check/${email}`, { headers: this.reqHeader, context: publicPageErrors() })
  }

  calculateProductPrice(contractDate: string, startDate: string, endDate: string, idProduct: number, paymentMethodId: number, numDependents: number, priceType: string): Observable<ProductCalculatePrice> {
    const params = `contractDate=${contractDate}&startDate=${startDate}&endDate=${endDate}&idProduct=${idProduct}&paymentMethod=${paymentMethodId}&numDependants=${numDependents}&priceType=${priceType}`;
    return this.http.get<ProductCalculatePrice>(`${this.baseUrl}/public/price-calculator?${params}`, { headers: this.reqHeader, context: publicPageErrors() });
  }

  calculatePaymentPlan(contractDate: string, startDate: string, endDate: string, idProduct: number, paymentMethodId: number, numDependents: number, priceType: string): Observable<PaymentPlanCalculation> {
    const params = `contractDate=${contractDate}&startDate=${startDate}&endDate=${endDate}&idProduct=${idProduct}&paymentMethod=${paymentMethodId}&numDependants=${numDependents}&priceType=${priceType}`;
    return this.http.get<PaymentPlanCalculation>(`${this.baseUrl}/public/payment-plan-calculator?${params}`, { headers: this.reqHeader, context: publicPageErrors() });
  }

  createClientAndCoverageProgram(transactionData: Transaction):Observable<CreateClientTransactionInvoice>{
    return this.http.post<CreateClientTransactionInvoice>(`${this.baseUrl}/public/clients/register`, transactionData, { headers: this.reqHeader, context: publicPageErrors() });
  }

  getAffiliateInvite(code: string): Observable<{ success: boolean; idUser: number }> {
    return this.http.get<{ success: boolean; idUser: number }>(`${this.baseUrl}/public/invites/${code}`, { headers: this.reqHeader, context: publicPageErrors() });
  }

  /** Estado del primer pago de una inscripción; `token` es el paymentStatusToken devuelto por el registro. */
  getEnrollmentFirstPayment(idTransaction: number, token: string): Observable<FirstPaymentStatus> {
    return this.http.get<FirstPaymentStatus>(
      `${this.baseUrl}/public/enrollment/${idTransaction}/first-payment?token=${encodeURIComponent(token)}`,
      { headers: this.reqHeader, context: publicPageErrors() }
    );
  }

}
